import $http from '@/plugins/axios'
import { removeNamespace } from '@/utils/helpers'

export const BINDINGS_TYPES = {
  mutations: {
    SET_LOADING: 'bindings/SET_LOADING',
    SET_FORMATS: 'bindings/SET_FORMATS',
    SET_PAGED_BINDINGS: 'bindings/SET_PAGED_BINDINGS',
    SET_TOTAL_BINDINGS_COUNT: 'bindings/SET_TOTAL_BINDINGS_COUNT',
    SET_BINDINGS_TABLE_OPTIONS: 'bindings/SET_BINDINGS_TABLE_OPTIONS',
    SET_BINDINGS_SEARCH_OPTIONS: 'bindings/SET_BINDINGS_SEARCH_OPTIONS',
    SET_SELECTED_BINDING: 'bindings/SET_SELECTED_BINDING',
    SET_SELECTED_BINDING_FORMAT: 'bindings/SET_SELECTED_BINDING_FORMAT'
  },
  actions: {
    fetchBindingsPaged: 'bindings/fetchBindingsPaged',
    fetchBinding: 'bindings/fetchBinding',
    fetchFormats: 'bindings/fetchFormats',
    setFormat: 'bindings/setFormat',
    saveBinding: 'bindings/saveBinding'
  }
}

const _types = removeNamespace('bindings', BINDINGS_TYPES)

const state = () => ({
  loading: false,
  formats: [],
  bindingsTableOptions: {
    page: 1,
    itemsPerPage: 10
  },
  bindingsSearchOptions: {
    skipCount: 0,
    maxResultCount: 10,
    keyword: null
  },
  pagedBindings: [],
  totalBindingsCount: 0,
  selectedBinding: {}
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_FORMATS] (state, result) {
    state.formats = result
  },
  [_types.mutations.SET_PAGED_BINDINGS] (state, pagedResult) {
    state.pagedBindings = pagedResult
  },
  [_types.mutations.SET_TOTAL_BINDINGS_COUNT] (state, count) {
    state.totalBindingsCount = count
  },
  [_types.mutations.SET_BINDINGS_TABLE_OPTIONS] (state, options) {
    state.bindingsTableOptions = options
  },
  [_types.mutations.SET_BINDINGS_SEARCH_OPTIONS] (state, options) {
    state.bindingsSearchOptions = options
  },
  [_types.mutations.SET_SELECTED_BINDING] (state, binding) {
    state.selectedBinding = binding
  },
  [_types.mutations.SET_SELECTED_BINDING_FORMAT] (state, format) {
    state.selectedBinding.format = format
    state.selectedBinding.productFormatId = format.id
  }
}

const actions = {
  [_types.actions.fetchBindingsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().get(`admin/bindings`, {
      params: state.bindingsSearchOptions
    })
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_BINDINGS, items)
        commit(_types.mutations.SET_TOTAL_BINDINGS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchFormats] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().get('admin/formats')
      .then((res) => {
        commit(_types.mutations.SET_FORMATS, res)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchBinding] ({ state, commit }, id) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().get(`admin/bindings/${id}`)
      .then((res) => {
        commit(_types.mutations.SET_SELECTED_BINDING, res)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.setFormat] ({ state, commit }, format) {
    commit(_types.mutations.SET_SELECTED_BINDING_FORMAT, format)
  },
  [_types.actions.saveBinding] ({ state, commit }, binding) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().patch(`admin/bindings/${binding.id}`, binding)
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
